module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_02.8880c04f.jpg";